import axios from '@/services/httpClient';
import { useAuthStore } from '../stores/authStore';

export const getUserFeedbacks = async (params = {}, retryAttempt = false) => {
    const authStore = useAuthStore();

    try {
        const response = await axios.get('/nora_superadmin/user_feedbacks', {
            headers: {
                Authorization: `Bearer ${authStore.accessToken}`,
            },
            params,
        });

        return response.data;
    } catch (error) {
        if (error.response?.status === 401 && !retryAttempt) {
            await authStore.refreshAccessToken();
            return getUserFeedbacks(params, true);
        }
        throw error;
    }
}

export const getFeedbackMedia = async (mediaUuid, retryAttempt = false) => {
    const authStore = useAuthStore();

    try {
        const response = await axios.get(`/nora_superadmin/case/${mediaUuid}`, {
            headers: {
                Authorization: `Bearer ${authStore.accessToken}`,
            },
            params: {
                withImage: true,
            },
        });

        return response.data;
    } catch (error) {
        if (error.response?.status === 401 && !retryAttempt) {
            await authStore.refreshAccessToken();
            return getFeedbackMedia(mediaUuid, true);
        }
        throw error;
    }
}
